module.exports = __webpack_public_path__ + "img/female.83593983.jpg";